import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import styles from './VbScrubBarProgress.module.less';

@Component({
	selector: 'vb-scrub-bar-progress',
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: ``,
	host: {
		'[class]': 'styles.root'
	},
    standalone: false
})
export class VbScrubBarProgressComponent {
	@Input() @HostBinding('style.width') public progressPercentage: string;

	public readonly styles = styles;

}
